import React from 'react';
import "./DeviceCard.css";
import { useTranslation } from 'react-i18next';
import printerIcon from '../../../assets/images/printer-icon.svg';
import EnrollmentFailedPrinterIcon from '../../../assets/images/alert-printer-icon.svg'

const DeviceCard = ({ device, index, selectedDevice, onClick, displayPrinterImage = true, cname = null }) => {
    const { t } = useTranslation(["translation"]);

    const services = [];

    if (device?.services?.ecopro) {
        services.push({
            label: t('MY_DEVICES.ENROLLED_SERVICES.ECOPRO_SERVICE'),
            isSuccess: device.services.ecopro.isSuccess
        });
    }

    if (device?.services?.brother) {
        services.push({
            label: t('MY_DEVICES.ENROLLED_SERVICES.BPLUS_SERVICE'),
            isSuccess: device.services.brother.isSuccess
        });
    }

    return (
        <div
            key={index}
            className={`mydevices-corousel-card ${cname} ${(selectedDevice?.deviceId === device?.deviceId)
                ? 'selected' : 'unselectedDevice'
                }`}
            onClick={() => onClick(device)}
        >
            {
                (displayPrinterImage) &&
                <div className="mydevices-corousel-header">
                    <img
                        alt="printer"
                        className="mydevices-corousel-device-image"
                        src={device?.imagePath}
                    />
                </div>
            }
            <div className="mydevices-corousel-details">
                <h2 className="mydevices-corousel-name">{device.deviceName}</h2>
                <div className="mydevice-carousel-device-container">
                    <div className="mydevice-carousel-device-info-wrapper">
                        <span className='label'>{t("MY_DEVICES.DEVICE_CARD.DEVICE_NAME")}</span>
                        <span className='value'>{device.model}</span>
                    </div>
                    <div className="mydevice-carousel-device-info-wrapper">
                        <span className='label'>{t("MY_DEVICES.DEVICE_CARD.SERIAL_NUMBER")}</span>
                        <span className='value'>{device.serialNumber}</span>
                    </div>
                    <div className="mydevice-carousel-device-info-wrapper">
                        <span className='label'>{t("MY_DEVICES.DEVICE_CARD.CURRENT_PLAN")}</span>

                        {
                            services.map((service, index) => (
                                <span
                                    key={index}
                                    className={service.isSuccess ? "value" : "enrollment-failed-value"}
                                >
                                    {
                                        service.isSuccess
                                            ? service.label
                                            : `${service.label} (${t('ECOPRO_ENROLLMENT_ERROR_MESSAGE.ENROLLMENT_FAILED_MESSAGE')})`
                                    }

                                    {index < services.length - 1 && ', '}
                                </span>
                            ))
                        }
                    </div>

                </div>
            </div>
            <div className='printer-icon-wrapper'>
                <img
                    src={
                        device?.services?.ecopro?.isSuccess === false
                            ? EnrollmentFailedPrinterIcon
                            : printerIcon
                    }
                    alt="printer status"
                />
            </div>
        </div>
    );
};

export default DeviceCard;
